import React, { useState } from 'react';
import { Table } from '@ajaibid/components';

import { styTable, styWrapper } from './style';
import ExpandableMFDetail from '../component/expandable';
import ModalStatusMF from '../component/ModalStatus';
import useMFHistoryColumns from './hooks/useMFHistoryColumns';
import useHistoryMF from './hooks/useHistoryMF';

function getRowId(row, ix, parent) {
  return `${parent ? `${parent?.id}__` : ''}${row?.order_no || ix}`;
}

function renderRowExpand(row) {
  return <ExpandableMFDetail item={row.original} source="riwayat" />;
}

const MutualFundOrder = () => {
  const { data, fetchNextPage, isInitialLoading, isFetchingNextPage } = useHistoryMF();
  const [modal, setModal] = useState(null);
  const columns = useMFHistoryColumns(setModal);
  const showModal = !!modal;
  const closeModal = () => setModal(null);

  return (
    <div className={styWrapper}>
      <Table
        className={styTable}
        data={data}
        columns={columns}
        options={{ isHeaderVisible: true, isRowExpandable: true }}
        fetchNext={fetchNextPage}
        getRowId={getRowId}
        isInitialLoading={isInitialLoading}
        isFetchingNext={isFetchingNextPage}
        renderRowExpand={renderRowExpand}
        emptyStateContent="Mulai bertransaksi dan lihat statusnya di sini."
      />
      <ModalStatusMF show={showModal} onClose={closeModal} item={modal} />
    </div>
  );
};

export default MutualFundOrder;
